import { IconProps } from "../../utils/global-types/global-types";

const HomeIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <g clipPath="url(#clip0_6715_93155)">
        <path
          fill="currentColor"
          d="M15.294 8.376 9.28 2.613a.406.406 0 0 0-.562 0L2.7 8.383a.678.678 0 0 0 .477 1.16h.948v5.144c0 .449.364.813.813.813H7.24a.406.406 0 0 0 .406-.407v-3.52c0-.075.06-.136.135-.136h2.438c.074 0 .135.061.135.136v3.52c0 .225.182.407.406.407h2.303a.813.813 0 0 0 .812-.813V9.541h.948a.678.678 0 0 0 .47-1.165"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_6715_93155">
          <path fill="#fff" d="M2.5 2.5h13v13h-13z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default HomeIcon;
